<template lang="pug">
v-card.page-card
    v-card-text
        Alert
        .alert-text.mb-6 {{ $t('Auth.__VerificationNote') }}
        v-text-field.page-input-field(
            solo,
            dense,
            outlined,
            :readonly="email != null",
            :value="email"
        )
        .text.mb-2(v-if="countdown != 0") {{ $t('Auth.__ResendHint', { sec: this.countdown }) }}
        v-btn.page-btn.mb-6(
            block,
            rounded,
            color="primary",
            @click="resendEmail",
            :disabled="countdown != 0"
        ) {{  $t("Auth.__Resend"),  }}
        //-{{resendBtnTitle}}

        //- .text-or.text-center.mb-4 
        //-     span 或是
        //- v-btn.google-btn.page-btn.mb-4(block rounded dark color="#4285f4") 
        //-         v-avatar(left size="30" )
        //-             v-img(src="@/assets/images/icon-google.png")
        //-         |使用google帳號註冊
        //- .text.mb-10 
        //-     router-link(to="/login") 已有帳號，前往登入
        //- .text 
        //-     span 繼續使用即代表你閱讀並同意我們的 
        //-     router-link(to="/")  網站服務條款
        //-     span  以及 
        //-     router-link(to="/") 隱私權政策
</template>

<script>
import * as textfieldUtils from "@/utils/textfield.js"

export default {
  props: ["email", alert],
  data() {
    return {
      rules: textfieldUtils.rules,
      alertText: "",
      resendBtnTitle: "",
      resendBtnTitle02: this.$t("Auth.__Resend"),
      countdown: 10,
      interval: null
    }
  },
  methods: {
    resendEmail() {
      // this.registerStep = 1;
      this.$store
        .dispatch("auth/resentEmail")
        .then(function(response) {}.bind(this))
        .catch(
          function(error) {
            this.alertText = error.message
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
      this.startResendTimer()
    },
    startResendTimer() {
      this.countdown = 60
      this.resendBtnTitle = this.resendBtnTitle01
      var interval = setInterval(
        function() {
          this.countdown = this.countdown > 0 ? this.countdown - 1 : 0
          this.resendBtnTitle = this.resendBtnTitle01
          if (this.countdown == 0) {
            clearInterval(interval)
            this.resendBtnTitle = this.resendBtnTitle02
          }
        }.bind(this),
        1000
      )
    }
  },
  computed: {
    resendBtnTitle01() {
      return this.$t("Auth.__ResendHint", { sec: this.countdown })
    }
  },
  mounted() {
    if (this.email != null) {
      this.startResendTimer()
    }
    if (this.alert) {
      this.$store.dispatch("global/showAlert", this.alert)
    }
    console.log(this.$route.params)
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/login.scss";

.register-stepper {
  box-shadow: 0 0 0 0;
  .v-stepper__content {
    padding: 0;
  }
}
</style>
